/* ============================================================
   VitaRise Wellness — theme.js
   Mobile menu drawer, FAQ accordion, sticky header shadow,
   product thumbnails, collection sort.
   ============================================================ */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    /* ---------- Sticky header shadow ---------- */
    var header = document.getElementById('SiteHeader');
    function onScroll() {
      if (!header) return;
      if (window.scrollY > 8) {
        header.classList.add('site-header--scrolled');
      } else {
        header.classList.remove('site-header--scrolled');
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    /* ---------- Mobile nav drawer ---------- */
    var toggle = document.getElementById('MobileMenuToggle');
    var closeBtn = document.getElementById('MobileMenuClose');
    var drawer = document.getElementById('MobileNavDrawer');
    var overlay = document.getElementById('MobileNavOverlay');

    function openDrawer() {
      if (!drawer) return;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      if (overlay) overlay.hidden = false;
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }
    function closeDrawer() {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      if (overlay) overlay.hidden = true;
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    if (toggle) toggle.addEventListener('click', openDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });

    /* ---------- FAQ accordion ---------- */
    var faqQuestions = document.querySelectorAll('.faq-item__question');
    faqQuestions.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.faq-item');
        var answer = item.querySelector('.faq-item__answer');
        var isOpen = item.classList.contains('is-open');

        // Close all, then open the tapped one (classic accordion)
        document.querySelectorAll('.faq-item.is-open').forEach(function (other) {
          other.classList.remove('is-open');
          other.querySelector('.faq-item__answer').hidden = true;
          other.querySelector('.faq-item__question').setAttribute('aria-expanded', 'false');
        });

        if (!isOpen) {
          item.classList.add('is-open');
          answer.hidden = false;
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });

    /* ---------- Product thumbnails ---------- */
    var mainImage = document.getElementById('ProductMainImage');
    var thumbs = document.querySelectorAll('.product-page__thumb');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-src');
        if (mainImage && src) {
          mainImage.src = src;
          var thumbImg = thumb.querySelector('img');
          if (thumbImg && thumbImg.alt) mainImage.alt = thumbImg.alt;
        }
      });
    });

    /* ---------- Variant price update ---------- */
    var variantSelect = document.getElementById('ProductVariantSelect');
    var priceEl = document.getElementById('ProductPrice');
    var variantIdInput = document.getElementById('ProductVariantId');
    if (variantSelect) {
      variantSelect.addEventListener('change', function () {
        var selected = variantSelect.options[variantSelect.selectedIndex];
        if (variantIdInput) variantIdInput.value = selected.value;
        if (priceEl) {
          var parts = selected.text.split('—');
          if (parts.length > 1) priceEl.textContent = parts[1].trim();
        }
      });
    }

    /* ---------- Collection sort ---------- */
    var sortSelect = document.getElementById('SortBy');
    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sortSelect.value);
        window.location.href = url.toString();
      });
    }
  });
})();
